// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alertContainer {
  position: fixed;
  bottom: 20px;
  right: 10px;
  max-width: 460px;
  margin: 0 auto;
  padding: 20px;
  z-index: 9999;
}

.alertContainer.show-background::before {
  position: fixed;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: -1;
}

.custom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

/* Backdrop */
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
}

/* Popup Container */
.popup-container {
  background: #fff;
  border-radius: 8px;
  width: 35%;
  min-width: 350px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease-in-out;
}

/* Header */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.popup-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-button {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

/* Body */
.popup-body {
  padding: 16px;
  font-size: 14px;
  color: #555;
}

/* Actions */
.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
}

.cancel-button {
  background: none;
  border: 1px solid #ccc;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.enable-button {
  background: #1DAFBA;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.auth-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AACF;;AAGE;EACE,eAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AAAJ;;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA,aAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA,oBAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;EACA,kCAAA;AAAF;;AAGA,WAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA,SAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAAF;;AAGA,YAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA,cAAA;AACA;EACE;IACE,UAAA;IACA,qBAAA;EAAF;EAEA;IACE,UAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;AADF","sourcesContent":[".alertContainer {\n  position: fixed;\n  bottom: 20px;\n  right: 10px;\n  max-width: 460px;\n  margin: 0 auto;\n  padding: 20px;\n  z-index: 9999;\n}\n\n.alertContainer {\n  &.show-background::before {\n    position: fixed;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0.6);\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    z-index: -1;\n  }\n}\n.custom-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n//---\n/* Backdrop */\n.popup-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9000;\n}\n\n/* Popup Container */\n.popup-container {\n  background: #fff;\n  border-radius: 8px;\n  width: 35%;\n  min-width: 350px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Header */\n.popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.popup-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n/* Body */\n.popup-body {\n  padding: 16px;\n  font-size: 14px;\n  color: #555;\n}\n\n/* Actions */\n.popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 16px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancel-button {\n  background: none;\n  border: 1px solid #ccc;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.enable-button {\n  background: #1DAFBA;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.auth-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 9999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
